export default "__VITE_ASSET__CXhPDHjs__"